exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal[data-v-59e5df89]{background-color:rgba(0,0,0,.8)}.transparent[data-v-59e5df89]{background-color:transparent;box-shadow:none;border:none}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/reusable/Modal.vue"],"names":[],"mappings":"AACA,wBACE,+BAAqC,CACtC,AACD,8BACE,6BAA8B,AAC9B,gBAAiB,AACjB,WAAa,CACd","file":"Modal.vue","sourcesContent":["\n.modal[data-v-59e5df89] {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.transparent[data-v-59e5df89] {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59e5df89","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reusable/Modal.vue
// module id = 978
// module chunks = 6